import type React from 'react';

import Typography from '@mui/material/Typography';

import './OnboardingHeader.scss';

export interface OnboardingHeaderProps {
  description: React.ReactNode;
  title: string;
}
const OnboardingHeader = ({ description, title }: OnboardingHeaderProps) => {
  return (
    <div className="Mfw-OnboardingHeader-root">
      <Typography variant="h3">{title}</Typography>
      <div className="Mfw-OnboardingHeader-description">
        {typeof description === 'string' ? (
          <Typography component="span" variant="body1">
            {description}
          </Typography>
        ) : (
          description
        )}
      </div>
    </div>
  );
};

export default OnboardingHeader;
